module.exports = __webpack_public_path__ + "img/imge.6b32f6a4.png";